import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { setSideMenuSelectedItem, setToolbarTitle } from "../../../redux/actions";
import { releaseDetail } from "../../../network/api";
import Category from "../../util/category";
import Tasks from "../../util/tasks";
import Files from "../../util/files";
import Links from "../../util/links";
import IncludedReleases from "../../util/included-releases";
import ExtraInfo from "../../util/extra-info";
import { ReactComponent as IconLab } from "../../../resources/image/ic_lab.svg";
import { ReactComponent as IconPublicRelease } from "../../../resources/image/ic_public_release.svg";
import { check_it, tasks_done_in_last_release, rolled_back, test_version_details, public_version_details, version_code, version_name, download_it, extra_information } from "../../../resources/string/strings"
import Loading from "../../util/page-loading";

class Releases extends Component {
  state = {
    pageTitle: "جزییات ریلیز",
    pageTag: "releases",
    data: undefined
  };

  componentDidMount() {
    this.props.setSideMenuSelectedItem(this.state.pageTag);
    this.props.setToolbarTitle(this.state.pageTitle);
    document.title = this.state.pageTitle;
    this.callDetailApi();
  }

  render() {

    return (

      <div className="fragment  text-center">
        {(this.state.data === undefined || this.state.data === null) && <Loading/>}

        {this.state.data !== undefined && this.state.data !== null && 
        <div style={{ marginBottom: 36 }} className="col-12 row mx-auto">

          <div className="app-card col-12 mt-0">

            <div>

              {this.state.data !== undefined && this.state.data.category !== undefined &&
                <div>
                  <Category
                    categoryId={this.state.data.category.id}
                    pictureUrl={this.state.data.category.pictureUrl}
                    titleFa={this.state.data.category.titleFa}
                    titleEn={this.state.data.category.titleEn}
                    showMoreLink={false}
                    />
                  <hr style={{ color: "gray" }} />

                </div>

              }

              {this.state.data.publicRelease &&
                <div style={{ color: "dimgrey", fontSize: 13, textAlign: "right", marginBottom: 10 }}>
                  <IconPublicRelease
                    className="p-0"
                    width="25"
                    height="25"
                  />

                  <span className="mr-2"> {public_version_details}</span>
                </div>
              }

              {!this.state.data.publicRelease &&
                <div style={{ color: "dimgrey", fontSize: 13, textAlign: "right", marginBottom: 10 }}>
                  <IconLab
                    className="p-0"
                    width="25"
                    height="25"
                  />

                  <span className="mr-2"> {test_version_details}</span>
                </div>
              }


              <div style={{ textAlign: "right", marginTop: 4 }}>
                <div className="mr-2 " style={{ fontSize: 14, color: "black", textDecoration: "none" }} >
                <span style={{ fontSize: 12, color: "silver"}}>{version_name}: </span>{this.state.data.versionName}
                </div>

              </div>

              {this.state.data.versionCode !== undefined && this.state.data.versionCode !== null && this.state.data.versionCode !== "" &&
                <div style={{ color: "slateblue", fontSize: 12, textAlign: "right" , marginTop: 5}}>
                  <span style={{ fontSize: 12, color: "silver"}}>{version_code}: </span> {this.state.data.versionCode}
                  </div>
              }

              <div style={{ color: "black", fontSize: 13, textAlign: "right", marginTop: 8 }}>
                {this.state.data.dateJalali}
              </div>


              {this.state.data.rollback !== undefined && this.state.data.rollback &&
                <div className="mt-2" style={{ color: "red", fontSize: 11, textAlign: "right", fontWeight: "bold" }}>
                  {rolled_back}
                </div>
              }


              {this.state.data.tasks !== undefined && this.state.data.tasks !== null && this.state.data.tasks.length > 0 &&
                <div className="mt-3">
                  <hr style={{ color: "gray" }} />
                  <Tasks
                    tasks={this.state.data.tasks}
                    title={tasks_done_in_last_release}
                  />
                </div>
              }

              {this.state.data.extraInfo !== undefined && this.state.data.extraInfo !== null && this.state.data.extraInfo !== "" &&
                <div style={{
                  textAlign: "right"
                }}>
                  <hr style={{ color: "gray" }} />
                  <ExtraInfo
                    extraInfo={this.state.data.extraInfo}
                    title={extra_information}
                  />
                </div>
              }

              {this.state.data.files !== undefined && this.state.data.files !== null && this.state.data.files.length > 0 &&
                <div className="mt-3">
                  <hr style={{ color: "gray" }} />
                  <Files
                    files={this.state.data.files}
                    title={download_it}
                  />
                </div>
              }

              {this.state.data.links !== undefined && this.state.data.links !== null && this.state.data.links.length > 0 &&
                <div className="mt-3">
                  <hr style={{ color: "gray" }} />
                  <Links
                    links={this.state.data.links}
                    title={check_it}
                  />
                </div>
              }


              {this.state.data.includedReleases !== undefined && this.state.data.includedReleases !== null && this.state.data.includedReleases.length > 0 &&
                <div className="mt-3">
                  <hr style={{ color: "gray" }} />
                  <IncludedReleases
                    includedReleases={this.state.data.includedReleases}
                    id={this.state.data.id}
                  />
                </div>
              }

            </div>


          </div>

        </div>
         }
      </div>
    );


  }

  getQueryString(tag, defaultValue) {
    const query = new URLSearchParams(this.props.location.search);
    let value = query.get(tag);
    if (value === null) {
      value = defaultValue;
    }
    return value;
  }

  /****
  ** NETWORK
  *****/

  callDetailApi() {
    var id = this.getQueryString("i", null)
    this.setState({ loading: true })
    releaseDetail(id, this.handleDetailApiSuccess, this.handleDetailFailure);
  }

  handleDetailApiSuccess = (data) => {
    this.setState({
      loading: false,
      data: data
    });
  };

  handleDetailFailure = (error) => {
    this.setState({ loading: false });
  }

}

//// REDUX STUFF
function mapStateToProps(state) {
  return {
    login: state.login,
    profile: state.profile,
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators({ setSideMenuSelectedItem: setSideMenuSelectedItem, setToolbarTitle: setToolbarTitle }, dispatch);
}

export default connect(
  mapStateToProps,
  matchDispatchToProps
)(Releases);
